<template>
    <div v-if="loaded" class="container__ask_code2">
        <section v-if="!isToRenderValeIngresso">
            <img class="cp-vertical-desktop-background" src="/assets/images/novo_corporativo/vertical_wave.svg" />
            <img class="cp-horizontal-desktop-background"
                src="/assets/images/novo_corporativo/home_horizontal_wave.svg" />
            <div class="main-corporative-container">
                <DonwloadApp />
                <div class="cp-header-logo">
                    <img class="bilheteria-logo" src="/assets/images/logocorporativobilheteria.png"
                        alt="Bilheteria.com" />
                </div>
                <div class="cp-header-title">
                    <h1 class="txts-askcode-bilheteria">BEM-VINDO AO PROGRAMA CORPORATIVO DE ENTRETENIMENTOS</h1>
                </div>
                <div class="cp-ask-code">
                    <p class='cp-title'>Insira o código de acesso da sua empresa</p>
                    <div class="cp-input">
                        <input type='text' v-model="form.pass" placeholder="Informe o código" class="form-control"
                            @keyup.enter="validateAskCode" />
                        <img src="/assets/images/novo_corporativo/arrow_go.png" alt="enviar" @click="validateAskCode" />
                    </div>
                </div>
                <div class="cp-body-description">
                    <span class='cp-description'>Esqueceu o código da empresa ou quer saber se ela está conveniada ao
                        programa - <a href='#' @click="$router.push('verifyAccess')">Clique aqui</a> </span>
                    <span class='cp-description' @click="$router.push('requestBws')">Para saber mais
                        sobre esse programa. - <a href='#'>Clique aqui</a>
                    </span>
                    <div class="cp-swiper">
                        <transition name="fade" mode="out-in">
                            <p key='dot1' class='cp-title' v-if='currentDot === 1'>O melhor entretenimento ao alcance do
                                seu clique.</p>
                            <p key='dot2' class='cp-title' v-if='currentDot === 2'>Viva experiências incríveis com
                                nossos ingressos.</p>
                            <p key='dot3' class='cp-title' v-if='currentDot === 3'>Ingressos para todos os gostos,
                                diversão garantida!</p>
                        </transition>

                        <div class="cp-dots">
                            <input type="radio" id="dot1" name="dots" value='1' v-model="currentDot" disabled>
                            <label for="dot1"></label>

                            <input type="radio" id="dot2" name="dots" value="2" v-model="currentDot" disabled>
                            <label for="dot2"></label>

                            <input type="radio" id="dot3" name="dots" value="3" v-model="currentDot" disabled>
                            <label for="dot3"></label>
                        </div>
                    </div>
                </div>
                <div class="cp-footer">
                    <div class="cp-social">
                        <a href="https://www.instagram.com/bilheteriacom/" target="blank">
                            <img class="social-media-img" src="/assets/images/novo_corporativo/instagram.svg"
                                alt="instagram" />
                        </a>
                        <a href="https://www.youtube.com/channel/UC1_gz9OCwU49rIzLZB0QlWg" target="blank">
                            <img class="social-media-img" src="/assets/images/novo_corporativo/youtube.svg"
                                alt="youtube" />
                        </a>
                        <a href="https://www.facebook.com/bilheteriacom/" target="blank">
                            <img class="social-media-img" src="/assets/images/novo_corporativo/facebook.svg"
                                alt="Facebook" /></a>
                        <a href="https://twitter.com/bilheteriacom" target="blank">
                            <img class="social-media-img" src="/assets/images/novo_corporativo/twitter.svg"
                                alt="twitter" /></a>
                        <a href="https://www.linkedin.com/company/bilheteria.com/" target="blank">
                            <img class="social-media-img" src="/assets/images/novo_corporativo/linkedin.svg"
                                alt="linkedin" /></a>
                    </div>
                    <div class="cp-apps">
                        <p class='cp-apps-title'>Baixe agora nosso APP </p>
                        <div>
                            <img class="social-media-img" src="/assets/images/novo_corporativo/google_play.svg"
                                alt="google play" />
                            <img class="social-media-img" src="/assets/images/novo_corporativo/apple_store.svg"
                                alt="apple store" />
                        </div>
                    </div>
                    <!-- only mobile -->
                    <lottie-player class="lottie-mobile" src="/assets/images/novo_corporativo/happy_friends.json"
                        background="transparent" speed="0.9" loop freeze autoplay style="height: auto">
                    </lottie-player>
                </div>
                <lottie-player class="lottie-desktop" src="/assets/images/novo_corporativo/happy_friends.json"
                    background="transparent" speed="0.9" loop freeze autoplay style="height: auto">
                </lottie-player>
            </div>
        </section>
        <ValeIngresso @login-fired-vale-ingresso="form.pass = $event; login()" v-else />
        <LottieLoader :loading="processing"></LottieLoader>
    </div>
</template>

<script>
import Vue from "vue";
import VModal from "vue-js-modal";
import config from "@/config";
import { func } from "@/functions";
import { authService } from "@/components/common/services/auth";
import { corporateService } from "@/components/common/services/corporate";
import { partnerService } from "@/components/common/services/partner";
import ValeIngresso from "./ValeIngresso.vue";
import DonwloadApp from "./DownloadApp.vue";
import LottieLoader from "@/components/loaders/LottieLoader";

Vue.use(VModal, {
    dynamic: true,
    injectModalsContainer: true,
});

export default {
    mixins: [func],
    name: "AskCode",
    head: {
        title: function () {
            return {
                inner: "",
                separator: " ",
                complement: "Programa Corporativo Bilheteria.com",
            };
        },
    },
    components: {
        ValeIngresso,
        DonwloadApp,
        LottieLoader
    },
    directives: {},
    methods: {
        startAutoSwiper() {
            this.intervalId = setInterval(() => {
                const idx = (Number(this.currentDot) + 1) % 4;
                this.currentDot = Number(idx) || 1;
            }, 5000); // Change phrase every 3 seconds
        },
        closeloginfather() {
            this.$route.matched[0].instances.default.$parent.modal_close_login();
        },
        getinfo() {
            this.processing = true;
            partnerService.getinfo().then(
                (response) => {
                    this.loaded = true;
                    this.processing = false;
                    if (this.validateJSON(response)) {
                        //console.log(response);
                        // this.initfb(response.hasfb, response.fb_appid);
                    }
                },
                (error) => {
                    this.loaded = true;
                    this.processing = false;
                }
            );
        },
    },
    data() {
        return {
            currentDot: 1,
            intervalId: null,
            processing: false,
            loaded: false,
            messageAlert: "",
            isToRenderValeIngresso: false,
            showwatch: "login",
            iscreatedvisible: true,
            hasfb: false,
            token: "",
            validateinfo: {
                login: true,
                pass: true,
                // passcode: true,
            },
            form: {
                auth_type: "",
                login: "",
                pass: "",
            },
        };
    },
    async mounted() {
        this.startAutoSwiper();
        this.$modal.hide("login");
        document.body.classList.add('black-background');
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
        document.body.classList.remove('black-background');
    },
    created() {
        if (this.$route.query.code) {
            this.$router.push("/");
        }
        const lottie = document.createElement('script')
        lottie.setAttribute('src', 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js')
        document.head.appendChild(lottie)

        if (this.$route.name === 'valeIngresso') {
            this.isToRenderValeIngresso = true;
        }

        this.ls_remove("fb_connect");
        this.getinfo();

        switch (window.location.pathname) {
            case "/loginandshopping/printafter":
                this.iscreatedvisible = false;
                break;
        }

        // this.getWindow.fbAsyncInit = function() {
        // }
    },
};
</script>

<style lang="scss" scoped>
.black-background {
    background-color: black !important;
}

.cp-horizontal-desktop-background {
    position: absolute;
    bottom: 0;
    width: 100%;
}

.cp-vertical-desktop-background {
    position: absolute;
    bottom: 0;
    top: 0;
    height: 100%;
    z-index: 99999;
    width: 20%;
}

.main-corporative-container {
    background-color: black;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    width: 100%;


    .cp-title {
        font-family: IBM Plex Sans;
        font-weight: 800;
        font-size: 1.4rem;
        color: white;
    }

    .cp-swiper {
        text-align: center;
        font-size: 1.4rem;

        .cp-title {
            color: #FF9701;
            font-size: 1.7rem;
            margin-top: 7rem;
        }

        input[type="radio"] {
            display: none;
        }

        label {
            display: inline-block;
            height: 15px;
            width: 15px;
            background-color: none;
            border-radius: 50%;
            border: 1px solid white;
            margin: 0 5px;
            cursor: pointer;
        }

        input[type="radio"]:checked+label {
            background-color: white;
        }
    }

    .bilheteria-logo {
        width: 100%;
    }

    .cp-header-title {
        display: flex;
        justify-content: center;
    }

    .cp-body-description {
        width: 90vw;
        display: flex;
        flex-direction: column;

        .cp-description {
            font-family: IBM Plex Sans;
            color: white;
            margin: 1.3rem 0;
            font-size: 1.4rem;
            font-weight: bold;
            text-align: center;

            a {
                color: #FF5946;
                font-weight: bold;
                text-decoration: underline solid #FF5946 0.1rem;
            }
        }
    }

    .txts-askcode-bilheteria {
        font-family: IBM Plex Sans;
        font-size: 1.8rem;
        width: 80vw;
        font-weight: 800;
        color: #FF9701;
        text-align: center;
        height: 5vw;
    }

    .cp-ask-code {
        text-align: center;

        .cp-input {
            display: flex;
            justify-content: center;
        }

        .form-control {
            border: 2px solid #FF5946;
            border-radius: 0.4rem;
            width: 30rem;
            height: 3rem;
            font-size: 16px;
        }

        img {
            position: absolute;
            width: 28px;
            height: 28px;
            transform: translate(13rem, 10px);
            cursor: pointer;
        }
    }

    .cp-social {
        margin-top: 1em;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;

        img {
            width: 50px;
        }

        img:hover {
            transform: scale(1.2) !important;
            transition: 0.5s ease-out;
        }
    }

    .lottie-desktop {
        position: absolute;
        z-index: 99999;
        bottom: 0;
        left: 0;
        left: 0;
        width: 17%;
    }

    .cp-apps {
        display: flex;
        flex-flow: column;
        align-items: center;
        position: absolute;
        right: 32px;
        bottom: 15%;

        .cp-apps-title {
            color: white;
            font-weight: bold;
            font-size: 1rem;
        }

        div>img {
            width: 130px;
        }
    }

    .cp-cute-image,
    .lottie-mobile {
        display: none;
    }
}

@media screen and (max-width: 500px) {

    .cp-desktop-background,
    .lottie-desktop,
    .cp-vertical-desktop-background,
    .cp-horizontal-desktop-background {
        display: none;
    }

    .lottie-mobile {
        height: auto;
        width: 50%;
        margin: 0 auto;
        display: block !important;
    }

    .main-corporative-container {
        height: auto;
        .cp-ask-code {
            .cp-title {
                font-size: 1.1rem;
            }

            .form-control {
                width: 68vw;
                border: 0.5vw solid red;
                border-radius: 0.7rem;
                height: 12.5vw;
            }

            img {
                width: 5vw;
                height: 5vw;
                transform: translate(28vw, 70%);
            }
        }

        .txts-askcode-bilheteria {
            height: 17vw;
            font-size: 1rem;
        }

        .cp-social {
            margin-top: 5em;

            img {
                width: 30px;
            }
        }

        .cp-footer {
            position: relative;
            bottom: 0;
            width: 100%;
            background-size: cover;
            background-repeat: no-repeat;
            background-image: url('/assets/images/novo_corporativo/wave_mobile.png');
        }

        .cp-apps {
            display: none;

        }

        .cp-body-description .cp-description {
            font-size: 0.8rem;
        }

        .cp-swiper .cp-title {
            font-size: 1.2rem;
            margin-top: 3rem;
        }

        .cp-cute-image {
            display: flex;
            justify-content: center;
            margin-top: 2rem;

            img {
                height: 36vw;
            }
        }
    }

}
</style>